import { useAuth0 } from "@auth0/auth0-react";
import moment, { Moment } from "moment";
import useDealBuilderRealTimeAAAStore from "../../stores/deal-builder-real-time-aaa.store.ts";
import SplineApi from "../../tools/spline-api.js";

export default function useRealTimeAAA() {
  const { getAccessTokenSilently } = useAuth0();
  const { lastFetchDate, realTimeAAA, setRealTimeAAA } = useDealBuilderRealTimeAAAStore();

  /**
   * Fetches the real time AAA.
   */
  async function fetchRealTimeAAA(): Promise<number[]> {
    const token = await getAccessTokenSilently();
    const splineApi = new SplineApi(token);
    return (await splineApi.getLatestCurve()).map(x => x[1] / 100);
  }

  /**
   * Returns the real time AAA
   */
  async function getRealTimeAAA(): Promise<number[]> {
    // Don't refetch if the data is recent
    if (Math.abs(lastFetchDate.diff(moment(), "minutes")) <= 3) return realTimeAAA;

    const newRealTime = await fetchRealTimeAAA();
    setRealTimeAAA(newRealTime);
    return newRealTime;
  }

  /**
   * Returns the real time AAA aligned with the market conditions date
   */
  async function getAlignedRealTimeAAA(
    marketConditionsDate: Moment,
    principalDates: string[]
  ): Promise<[number[], any]> {
    const realTimeAAA = await getRealTimeAAA();
    const yields: number[] = [];

    for (const dateStr of principalDates) {
      const maturityDate = moment(dateStr);
      const yearsToMaturity = Math.round(
        maturityDate.diff(marketConditionsDate, "years", true)
      );

      const boundedYearsToMaturity = Math.max(1, yearsToMaturity)
      yields.push(realTimeAAA[boundedYearsToMaturity - 1]);
    }
    
    const minutes = Math.floor(moment().minutes() / 5) * 5;
    const dateStr = moment().minutes(minutes).format("MM/DD/YYYY HH:mm");
    const title = "\"AAA\"";
    const description = "Spline Data (AAA, GO, 5%, Large) " + dateStr + ".";
    return [yields, { title, description }]
  }

  return { getRealTimeAAA, getAlignedRealTimeAAA };
}
